<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fzqpU4/tc-custom/9781611177534.jpg?1718183632387" alt="This image is the cover for the book Rhetoric of Mao Zedong, Studies in Rhetoric & Communication"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rhetoric of Mao Zedong, Studies in Rhetoric & Communication
      </h1>
      <p class="bookDescription body article font2">
        <p><b>This thorough examination of Mao’s speeches and writings and how they reshaped a nation “is critical to an understanding of modern China” (<i>Choice</i>).</b><br/>  <br/> Mao Zedong fundamentally transformed China from a Confucian society characterized by hierarchy and harmony into a socialist state guided by communist ideologies of class struggle and radicalization. It was a transformation made possible largely by Mao’s rhetorical ability to attract, persuade, and mobilize millions of Chinese people. In this book, Xing Lu analyzes Mao’s speeches and writings over a span of sixty years, tracing the sources and evolution of his discourse, analyzing his skills as an orator and mythmaker, assessing his symbolic power and continuing presence in contemporary China, and observing that Mao’s rhetorical legacy has been commoditized, culturally consumed, and politically appropriated since his death.<br/>  <br/> Applying both Western rhetorical theories and Chinese rhetorical concepts to reach a more nuanced and sophisticated understanding of his rhetorical legacy, Lu shows how Mao employed a host of rhetorical appeals and strategies drawn from Chinese tradition and how he interpreted the discourse of Marxism-Leninism to serve foundational themes of his message. She traces the historical contexts in which these themes, his philosophical orientations, and his political views were formed and how they transformed China and Chinese people.<br/><br/> Lu also examines how certain ideas are promoted, modified, and appropriated in Mao’s rhetoric. His appropriation of Marxist theory of class struggle, his campaigns of transforming common people into new communist advocates, his promotion of Chinese nationalism, and his stand on China’s foreign policy all contributed to and were responsible for reshaping Chinese thought patterns, culture, and communication behaviors.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Xing Lu
      </h2>
      
      <p class="authorDescription body article"><P>Xing Lu is a professor of communication at DePaul University in Chicago, Illinois. Born and raised in China, she received her doctorate in rhetoric and communication from the University of Oregon. Lu is the author or editor of five books, including Rhetoric in Ancient China, Fifth to Third Century B.C.E., winner of the James A. Winans–Herbert A. Wichelns Memorial Award for Distinguished Scholarship in Rhetoric and Public Address, and Rhetoric of the Chinese Cultural Revolution, both published by the University of South Carolina Press.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of South Carolina Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6f6fc4a3